<template>
 <TheToast></TheToast>
<NavBar v-if="$route.meta.showNav != false"></NavBar>
<MenuBar v-if="$route.meta.showNav != false"></MenuBar>
  <router-view/>
</template>


<script>
import NavBar from './components/NavBar.vue'
import MenuBar from './components/MenuBar.vue'
export default {
    components: { NavBar, MenuBar },
}
</script>

